import PropTypes from 'prop-types';

import { hasFeaturePermissions } from 'src/module/authentication/selector';
import { useSelector } from 'react-redux';

export default function FeatureFence (props) {
  const {
    can,
    noPermissionComponent,
    children
  } = props;

  const render: boolean = useSelector(hasFeaturePermissions(can));

  if (render) {
    return children;
  }
  if (noPermissionComponent) {
    return noPermissionComponent;
  }

  return null;
}

FeatureFence.propTypes = {
  can: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]).isRequired,
  noPermissionComponent: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ])
};

FeatureFence.defaultProps = {
};
